<template>
  <span
    v-if="mode && (mode == 'clone' || mode == 'edit' ||mode == 'new')"
    :class="show ? 'red--text' : 'transparent--text d-none d-lg-inline'"
    >*</span
  >
</template>

<script>
export default {
  name: "Requird",

  props: ["show", "mode"],
};
</script>
